import { useContext, useMemo } from "react";
import { DataContext } from "../context/DataContext";

// Import IDMatchPlus locale files
import idmatchplusEn from "../locales/idmatchplus/en.json";
import idmatchplusEs from "../locales/idmatchplus/es.json";

// Import Brazil CPF locale files
import brazilCpfEn from "../locales/brazil-cpf/en.json";
import brazilCpfEs from "../locales/brazil-cpf/es.json";
import brazilCpfPtBR from "../locales/brazil-cpf/pt-BR.json";

// Import mojeID locale files
import mojeidEn from "../locales/mojeid/en.json";
import mojeidCs from "../locales/mojeid/cs.json";

// Import BankID CZ locale files
import bankidCzEn from "../locales/bankid-cz/en.json";
import bankidCzCs from "../locales/bankid-cz/cs.json";

// Import Finnish Trust Network locale files
import finnishTrustNetworkEn from "../locales/finnish-trust-network/en.json";
import finnishTrustNetworkFi from "../locales/finnish-trust-network/fi.json";

// Import Modular locale files
import modularEn from "../locales/modular/en.json";
import modularCs from "../locales/modular/cs.json";
import modularFi from "../locales/modular/fi.json";

// Import Device Blocked locale files
import deviceBlockedEn from "../locales/device-blocked/en.json";
import deviceBlockedAr from "../locales/device-blocked/ar.json";
import deviceBlockedBg from "../locales/device-blocked/bg.json";
import deviceBlockedBs from "../locales/device-blocked/bs.json";
import deviceBlockedCs from "../locales/device-blocked/cs.json";
import deviceBlockedDa from "../locales/device-blocked/da.json";
import deviceBlockedDe from "../locales/device-blocked/de.json";
import deviceBlockedEl from "../locales/device-blocked/el.json";
import deviceBlockedEs from "../locales/device-blocked/es.json";
import deviceBlockedEs419 from "../locales/device-blocked/es-419.json";
import deviceBlockedEt from "../locales/device-blocked/et.json";
import deviceBlockedFa from "../locales/device-blocked/fa.json";
import deviceBlockedFi from "../locales/device-blocked/fi.json";
import deviceBlockedFr from "../locales/device-blocked/fr.json";
import deviceBlockedHe from "../locales/device-blocked/he.json";
import deviceBlockedHi from "../locales/device-blocked/hi.json";
import deviceBlockedHr from "../locales/device-blocked/hr.json";
import deviceBlockedHu from "../locales/device-blocked/hu.json";
import deviceBlockedHy from "../locales/device-blocked/hy.json";
import deviceBlockedId from "../locales/device-blocked/id.json";
import deviceBlockedIt from "../locales/device-blocked/it.json";
import deviceBlockedJa from "../locales/device-blocked/ja.json";
import deviceBlockedKo from "../locales/device-blocked/ko.json";
import deviceBlockedLt from "../locales/device-blocked/lt.json";
import deviceBlockedLv from "../locales/device-blocked/lv.json";
import deviceBlockedMs from "../locales/device-blocked/ms.json";
import deviceBlockedNb from "../locales/device-blocked/nb.json";
import deviceBlockedNl from "../locales/device-blocked/nl.json";
import deviceBlockedPl from "../locales/device-blocked/pl.json";
import deviceBlockedPt from "../locales/device-blocked/pt.json";
import deviceBlockedPtBR from "../locales/device-blocked/pt-BR.json";
import deviceBlockedRo from "../locales/device-blocked/ro.json";
import deviceBlockedRu from "../locales/device-blocked/ru.json";
import deviceBlockedSk from "../locales/device-blocked/sk.json";
import deviceBlockedSrRS from "../locales/device-blocked/sr-RS.json";
import deviceBlockedSrLatnRS from "../locales/device-blocked/sr-Latn-RS.json";
import deviceBlockedSv from "../locales/device-blocked/sv.json";
import deviceBlockedTh from "../locales/device-blocked/th.json";
import deviceBlockedTl from "../locales/device-blocked/tl.json";
import deviceBlockedTr from "../locales/device-blocked/tr.json";
import deviceBlockedUk from "../locales/device-blocked/uk.json";
import deviceBlockedUr from "../locales/device-blocked/ur.json";
import deviceBlockedVi from "../locales/device-blocked/vi.json";
import deviceBlockedZh from "../locales/device-blocked/zh.json";

// Import Handoff locale files
import handoffEn from "../locales/handoff/en.json";
import handoffAr from "../locales/handoff/ar.json";
import handoffBg from "../locales/handoff/bg.json";
import handoffBs from "../locales/handoff/bs.json";
import handoffCs from "../locales/handoff/cs.json";
import handoffDa from "../locales/handoff/da.json";
import handoffDe from "../locales/handoff/de.json";
import handoffEl from "../locales/handoff/el.json";
import handoffEs from "../locales/handoff/es.json";
import handoffEs419 from "../locales/handoff/es-419.json";
import handoffEt from "../locales/handoff/et.json";
import handoffFa from "../locales/handoff/fa.json";
import handoffFi from "../locales/handoff/fi.json";
import handoffFr from "../locales/handoff/fr.json";
import handoffHe from "../locales/handoff/he.json";
import handoffHi from "../locales/handoff/hi.json";
import handoffHr from "../locales/handoff/hr.json";
import handoffHu from "../locales/handoff/hu.json";
import handoffHy from "../locales/handoff/hy.json";
import handoffId from "../locales/handoff/id.json";
import handoffIt from "../locales/handoff/it.json";
import handoffJa from "../locales/handoff/ja.json";
import handoffKo from "../locales/handoff/ko.json";
import handoffLt from "../locales/handoff/lt.json";
import handoffLv from "../locales/handoff/lv.json";
import handoffMs from "../locales/handoff/ms.json";
import handoffNb from "../locales/handoff/nb.json";
import handoffNl from "../locales/handoff/nl.json";
import handoffPl from "../locales/handoff/pl.json";
import handoffPt from "../locales/handoff/pt.json";
import handoffPtBR from "../locales/handoff/pt-BR.json";
import handoffRo from "../locales/handoff/ro.json";
import handoffRu from "../locales/handoff/ru.json";
import handoffSk from "../locales/handoff/sk.json";
import handoffSrRS from "../locales/handoff/sr-RS.json";
import handoffSrLatnRS from "../locales/handoff/sr-Latn-RS.json";
import handoffSv from "../locales/handoff/sv.json";
import handoffTh from "../locales/handoff/th.json";
import handoffTl from "../locales/handoff/tl.json";
import handoffTr from "../locales/handoff/tr.json";
import handoffUk from "../locales/handoff/uk.json";
import handoffUr from "../locales/handoff/ur.json";
import handoffVi from "../locales/handoff/vi.json";
import handoffZh from "../locales/handoff/zh.json";

// Import COPPA locale files
import coppaEn from "../locales/coppa/en.json";
import coppaAr from "../locales/coppa/ar.json";
import coppaBg from "../locales/coppa/bg.json";
import coppaBs from "../locales/coppa/bs.json";
import coppaCs from "../locales/coppa/cs.json";
import coppaDa from "../locales/coppa/da.json";
import coppaDe from "../locales/coppa/de.json";
import coppaEl from "../locales/coppa/el.json";
import coppaEs from "../locales/coppa/es.json";
import coppaEs419 from "../locales/coppa/es-419.json";
import coppaEt from "../locales/coppa/et.json";
import coppaFa from "../locales/coppa/fa.json";
import coppaFi from "../locales/coppa/fi.json";
import coppaFr from "../locales/coppa/fr.json";
import coppaHe from "../locales/coppa/he.json";
import coppaHi from "../locales/coppa/hi.json";
import coppaHr from "../locales/coppa/hr.json";
import coppaHu from "../locales/coppa/hu.json";
import coppaHy from "../locales/coppa/hy.json";
import coppaId from "../locales/coppa/id.json";
import coppaIt from "../locales/coppa/it.json";
import coppaJa from "../locales/coppa/ja.json";
import coppaKo from "../locales/coppa/ko.json";
import coppaLt from "../locales/coppa/lt.json";
import coppaLv from "../locales/coppa/lv.json";
import coppaMs from "../locales/coppa/ms.json";
import coppaNb from "../locales/coppa/nb.json";
import coppaNl from "../locales/coppa/nl.json";
import coppaPl from "../locales/coppa/pl.json";
import coppaPt from "../locales/coppa/pt.json";
import coppaPtBR from "../locales/coppa/pt-BR.json";
import coppaRo from "../locales/coppa/ro.json";
import coppaRu from "../locales/coppa/ru.json";
import coppaSk from "../locales/coppa/sk.json";
import coppaSrRS from "../locales/coppa/sr-RS.json";
import coppaSrLatnRS from "../locales/coppa/sr-Latn-RS.json";
import coppaSv from "../locales/coppa/sv.json";
import coppaTh from "../locales/coppa/th.json";
import coppaTl from "../locales/coppa/tl.json";
import coppaTr from "../locales/coppa/tr.json";
import coppaUk from "../locales/coppa/uk.json";
import coppaUr from "../locales/coppa/ur.json";
import coppaVi from "../locales/coppa/vi.json";
import coppaZh from "../locales/coppa/zh.json";

// Import Age Estimation locale files
import ageEstimationEn from "../locales/age-estimation/en.json";
import ageEstimationAr from "../locales/age-estimation/ar.json";
import ageEstimationBg from "../locales/age-estimation/bg.json";
import ageEstimationBs from "../locales/age-estimation/bs.json";
import ageEstimationCs from "../locales/age-estimation/cs.json";
import ageEstimationDa from "../locales/age-estimation/da.json";
import ageEstimationDe from "../locales/age-estimation/de.json";
import ageEstimationEl from "../locales/age-estimation/el.json";
import ageEstimationEs from "../locales/age-estimation/es.json";
import ageEstimationEs419 from "../locales/age-estimation/es-419.json";
import ageEstimationEt from "../locales/age-estimation/et.json";
import ageEstimationFa from "../locales/age-estimation/fa.json";
import ageEstimationFi from "../locales/age-estimation/fi.json";
import ageEstimationFr from "../locales/age-estimation/fr.json";
import ageEstimationHe from "../locales/age-estimation/he.json";
import ageEstimationHi from "../locales/age-estimation/hi.json";
import ageEstimationHr from "../locales/age-estimation/hr.json";
import ageEstimationHu from "../locales/age-estimation/hu.json";
import ageEstimationHy from "../locales/age-estimation/hy.json";
import ageEstimationId from "../locales/age-estimation/id.json";
import ageEstimationIt from "../locales/age-estimation/it.json";
import ageEstimationJa from "../locales/age-estimation/ja.json";
import ageEstimationKo from "../locales/age-estimation/ko.json";
import ageEstimationLt from "../locales/age-estimation/lt.json";
import ageEstimationLv from "../locales/age-estimation/lv.json";
import ageEstimationMs from "../locales/age-estimation/ms.json";
import ageEstimationNb from "../locales/age-estimation/nb.json";
import ageEstimationNl from "../locales/age-estimation/nl.json";
import ageEstimationPl from "../locales/age-estimation/pl.json";
import ageEstimationPt from "../locales/age-estimation/pt.json";
import ageEstimationPtBR from "../locales/age-estimation/pt-BR.json";
import ageEstimationRo from "../locales/age-estimation/ro.json";
import ageEstimationRu from "../locales/age-estimation/ru.json";
import ageEstimationSk from "../locales/age-estimation/sk.json";
import ageEstimationSrRS from "../locales/age-estimation/sr-RS.json";
import ageEstimationSrLatnRS from "../locales/age-estimation/sr-Latn-RS.json";
import ageEstimationSv from "../locales/age-estimation/sv.json";
import ageEstimationTh from "../locales/age-estimation/th.json";
import ageEstimationTl from "../locales/age-estimation/tl.json";
import ageEstimationTr from "../locales/age-estimation/tr.json";
import ageEstimationUk from "../locales/age-estimation/uk.json";
import ageEstimationUr from "../locales/age-estimation/ur.json";
import ageEstimationVi from "../locales/age-estimation/vi.json";
import ageEstimationZh from "../locales/age-estimation/zh.json";

// Import Document Capture locale files
import documentCaptureEn from "../locales/document-capture/en.json";

// Import Face Capture locale files
import faceCaptureEn from "../locales/face-capture/en.json";
import faceCaptureAr from "../locales/face-capture/ar.json";
import faceCaptureBg from "../locales/face-capture/bg.json";
import faceCaptureBs from "../locales/face-capture/bs.json";
import faceCaptureCs from "../locales/face-capture/cs.json";
import faceCaptureDa from "../locales/face-capture/da.json";
import faceCaptureDe from "../locales/face-capture/de.json";
import faceCaptureEl from "../locales/face-capture/el.json";
import faceCaptureEs from "../locales/face-capture/es.json";
import faceCaptureEs419 from "../locales/face-capture/es-419.json";
import faceCaptureEt from "../locales/face-capture/et.json";
import faceCaptureFa from "../locales/face-capture/fa.json";
import faceCaptureFi from "../locales/face-capture/fi.json";
import faceCaptureFr from "../locales/face-capture/fr.json";
import faceCaptureHe from "../locales/face-capture/he.json";
import faceCaptureHi from "../locales/face-capture/hi.json";
import faceCaptureHr from "../locales/face-capture/hr.json";
import faceCaptureHu from "../locales/face-capture/hu.json";
import faceCaptureHy from "../locales/face-capture/hy.json";
import faceCaptureId from "../locales/face-capture/id.json";
import faceCaptureIt from "../locales/face-capture/it.json";
import faceCaptureJa from "../locales/face-capture/ja.json";
import faceCaptureKo from "../locales/face-capture/ko.json";
import faceCaptureLt from "../locales/face-capture/lt.json";
import faceCaptureLv from "../locales/face-capture/lv.json";
import faceCaptureMs from "../locales/face-capture/ms.json";
import faceCaptureNb from "../locales/face-capture/nb.json";
import faceCaptureNl from "../locales/face-capture/nl.json";
import faceCapturePl from "../locales/face-capture/pl.json";
import faceCapturePt from "../locales/face-capture/pt.json";
import faceCapturePtBR from "../locales/face-capture/pt-BR.json";
import faceCaptureRo from "../locales/face-capture/ro.json";
import faceCaptureRu from "../locales/face-capture/ru.json";
import faceCaptureSk from "../locales/face-capture/sk.json";
import faceCaptureSrRS from "../locales/face-capture/sr-RS.json";
import faceCaptureSrLatnRS from "../locales/face-capture/sr-Latn-RS.json";
import faceCaptureSv from "../locales/face-capture/sv.json";
import faceCaptureTh from "../locales/face-capture/th.json";
import faceCaptureTl from "../locales/face-capture/tl.json";
import faceCaptureTr from "../locales/face-capture/tr.json";
import faceCaptureUk from "../locales/face-capture/uk.json";
import faceCaptureUr from "../locales/face-capture/ur.json";
import faceCaptureVi from "../locales/face-capture/vi.json";
import faceCaptureZh from "../locales/face-capture/zh.json";

const locales = {
  idmatchplus: {
    en: idmatchplusEn,
    es: idmatchplusEs,
  },
  handoff: {
    en: handoffEn,
    ar: handoffAr,
    bg: handoffBg,
    bs: handoffBs,
    cs: handoffCs,
    da: handoffDa,
    de: handoffDe,
    el: handoffEl,
    es: handoffEs,
    "es-419": handoffEs419,
    et: handoffEt,
    fa: handoffFa,
    fi: handoffFi,
    fr: handoffFr,
    he: handoffHe,
    hi: handoffHi,
    hr: handoffHr,
    hu: handoffHu,
    hy: handoffHy,
    id: handoffId,
    it: handoffIt,
    ja: handoffJa,
    ko: handoffKo,
    lt: handoffLt,
    lv: handoffLv,
    ms: handoffMs,
    nb: handoffNb,
    nl: handoffNl,
    pl: handoffPl,
    pt: handoffPt,
    "pt-BR": handoffPtBR,
    ro: handoffRo,
    ru: handoffRu,
    sk: handoffSk,
    "sr-RS": handoffSrRS,
    "sr-Latn-RS": handoffSrLatnRS,
    sv: handoffSv,
    th: handoffTh,
    tl: handoffTl,
    tr: handoffTr,
    uk: handoffUk,
    ur: handoffUr,
    vi: handoffVi,
    zh: handoffZh,
  },
  "brazil-cpf": {
    en: brazilCpfEn,
    es: brazilCpfEs,
    "pt-BR": brazilCpfPtBR,
  },
  mojeid: {
    en: mojeidEn,
    cs: mojeidCs,
  },
  "bankid-cz": {
    en: bankidCzEn,
    cs: bankidCzCs,
  },
  "finnish-trust-network": {
    en: finnishTrustNetworkEn,
    fi: finnishTrustNetworkFi,
  },
  modular: {
    en: modularEn,
    cs: modularCs,
    fi: modularFi,
  },
  coppa: {
    en: coppaEn,
    ar: coppaAr,
    bg: coppaBg,
    bs: coppaBs,
    cs: coppaCs,
    da: coppaDa,
    de: coppaDe,
    el: coppaEl,
    es: coppaEs,
    "es-419": coppaEs419,
    et: coppaEt,
    fa: coppaFa,
    fi: coppaFi,
    fr: coppaFr,
    he: coppaHe,
    hi: coppaHi,
    hr: coppaHr,
    hu: coppaHu,
    hy: coppaHy,
    id: coppaId,
    it: coppaIt,
    ja: coppaJa,
    ko: coppaKo,
    lt: coppaLt,
    lv: coppaLv,
    ms: coppaMs,
    nb: coppaNb,
    nl: coppaNl,
    pl: coppaPl,
    pt: coppaPt,
    "pt-BR": coppaPtBR,
    ro: coppaRo,
    ru: coppaRu,
    sk: coppaSk,
    "sr-RS": coppaSrRS,
    "sr-Latn-RS": coppaSrLatnRS,
    sv: coppaSv,
    th: coppaTh,
    tl: coppaTl,
    tr: coppaTr,
    uk: coppaUk,
    ur: coppaUr,
    vi: coppaVi,
    zh: coppaZh,
  },
  "device-blocked": {
    en: deviceBlockedEn,
    ar: deviceBlockedAr,
    bg: deviceBlockedBg,
    bs: deviceBlockedBs,
    cs: deviceBlockedCs,
    da: deviceBlockedDa,
    de: deviceBlockedDe,
    el: deviceBlockedEl,
    es: deviceBlockedEs,
    "es-419": deviceBlockedEs419,
    et: deviceBlockedEt,
    fa: deviceBlockedFa,
    fi: deviceBlockedFi,
    fr: deviceBlockedFr,
    he: deviceBlockedHe,
    hi: deviceBlockedHi,
    hr: deviceBlockedHr,
    hu: deviceBlockedHu,
    hy: deviceBlockedHy,
    id: deviceBlockedId,
    it: deviceBlockedIt,
    ja: deviceBlockedJa,
    ko: deviceBlockedKo,
    lt: deviceBlockedLt,
    lv: deviceBlockedLv,
    ms: deviceBlockedMs,
    nb: deviceBlockedNb,
    nl: deviceBlockedNl,
    pl: deviceBlockedPl,
    pt: deviceBlockedPt,
    "pt-BR": deviceBlockedPtBR,
    ro: deviceBlockedRo,
    ru: deviceBlockedRu,
    sk: deviceBlockedSk,
    "sr-RS": deviceBlockedSrRS,
    "sr-Latn-RS": deviceBlockedSrLatnRS,
    sv: deviceBlockedSv,
    th: deviceBlockedTh,
    tl: deviceBlockedTl,
    tr: deviceBlockedTr,
    uk: deviceBlockedUk,
    ur: deviceBlockedUr,
    vi: deviceBlockedVi,
    zh: deviceBlockedZh,
  },
  "document-capture": {
    en: documentCaptureEn,
  },
  "face-capture": {
    en: faceCaptureEn,
    ar: faceCaptureAr,
    bg: faceCaptureBg,
    bs: faceCaptureBs,
    cs: faceCaptureCs,
    da: faceCaptureDa,
    de: faceCaptureDe,
    el: faceCaptureEl,
    es: faceCaptureEs,
    "es-419": faceCaptureEs419,
    et: faceCaptureEt,
    fa: faceCaptureFa,
    fi: faceCaptureFi,
    fr: faceCaptureFr,
    he: faceCaptureHe,
    hi: faceCaptureHi,
    hr: faceCaptureHr,
    hu: faceCaptureHu,
    hy: faceCaptureHy,
    id: faceCaptureId,
    it: faceCaptureIt,
    ja: faceCaptureJa,
    ko: faceCaptureKo,
    lt: faceCaptureLt,
    lv: faceCaptureLv,
    ms: faceCaptureMs,
    nb: faceCaptureNb,
    nl: faceCaptureNl,
    pl: faceCapturePl,
    pt: faceCapturePt,
    "pt-BR": faceCapturePtBR,
    ro: faceCaptureRo,
    ru: faceCaptureRu,
    sk: faceCaptureSk,
    "sr-RS": faceCaptureSrRS,
    "sr-Latn-RS": faceCaptureSrLatnRS,
    sv: faceCaptureSv,
    th: faceCaptureTh,
    tl: faceCaptureTl,
    tr: faceCaptureTr,
    uk: faceCaptureUk,
    ur: faceCaptureUr,
    vi: faceCaptureVi,
    zh: faceCaptureZh,
  },
  "age-estimation": {
    en: ageEstimationEn,
    ar: ageEstimationAr,
    bg: ageEstimationBg,
    bs: ageEstimationBs,
    cs: ageEstimationCs,
    da: ageEstimationDa,
    de: ageEstimationDe,
    el: ageEstimationEl,
    es: ageEstimationEs,
    "es-419": ageEstimationEs419,
    et: ageEstimationEt,
    fa: ageEstimationFa,
    fi: ageEstimationFi,
    fr: ageEstimationFr,
    he: ageEstimationHe,
    hi: ageEstimationHi,
    hr: ageEstimationHr,
    hu: ageEstimationHu,
    hy: ageEstimationHy,
    id: ageEstimationId,
    it: ageEstimationIt,
    ja: ageEstimationJa,
    ko: ageEstimationKo,
    lt: ageEstimationLt,
    lv: ageEstimationLv,
    ms: ageEstimationMs,
    nb: ageEstimationNb,
    nl: ageEstimationNl,
    pl: ageEstimationPl,
    pt: ageEstimationPt,
    "pt-BR": ageEstimationPtBR,
    ro: ageEstimationRo,
    ru: ageEstimationRu,
    sk: ageEstimationSk,
    "sr-RS": ageEstimationSrRS,
    "sr-Latn-RS": ageEstimationSrLatnRS,
    sv: ageEstimationSv,
    th: ageEstimationTh,
    tl: ageEstimationTl,
    tr: ageEstimationTr,
    uk: ageEstimationUk,
    ur: ageEstimationUr,
    vi: ageEstimationVi,
    zh: ageEstimationZh,
  },
};

/**
 * Hook to get localized text for components
 * Supports IDMatchPlus, Brazil CPF, Age Estimation, COPPA, mojeID, BankID CZ, Finnish Trust Network, Modular, and Face Capture components
 * Defaults to English if language is not set or unsupported
 */
const useLocale = (component = "idmatchplus") => {
  const { settings } = useContext(DataContext);

  const locale = useMemo(() => {
    const language = settings?.language?.toLowerCase();
    const componentLocales = locales[component];

    if (!componentLocales) {
      console.warn(`No locales found for component: ${component}`);
      return locales.idmatchplus.en;
    }

    // Default to English if language is not set or empty
    if (!language || language === "" || language === "en") {
      return componentLocales.en;
    }

    // Try exact match first (handles es-419, pt-BR, sr-RS, sr-Latn-RS, etc.)
    if (componentLocales[language]) {
      return componentLocales[language];
    }

    // Try with lowercase and normalized format (e.g., pt_br -> pt-BR)
    const normalizedLang = language.replace("_", "-");
    if (componentLocales[normalizedLang]) {
      return componentLocales[normalizedLang];
    }

    // Try base language (e.g., es-419 -> es, pt-BR -> pt)
    const baseLang = language.split("-")[0].split("_")[0];
    if (componentLocales[baseLang]) {
      return componentLocales[baseLang];
    }

    // Brazil CPF: Portuguese Brazilian support (legacy handling)
    if (component === "brazil-cpf") {
      if (baseLang === "br" || baseLang === "pt" || language === "portuguese") {
        return componentLocales["pt-BR"];
      }
    }

    // Fallback to English for any unsupported language
    return componentLocales.en;
  }, [settings?.language, component]);

  return locale;
};

export default useLocale;
